import { createStore, applyMiddleware, compose } from 'redux'
import { fromJS } from 'immutable'
import createSagaMiddleware from 'redux-saga'
import { routerMiddleware as createRouterMiddleware } from 'connected-react-router/immutable'
import { createBrowserHistory } from 'history'
import { persistStore } from 'redux-persist'

import { getIdentityProgress, getProfile } from 'store/entities/identity/actions'
import { isLoginByMagicLink, isStartPage } from 'store/entities/router/selectors'
// import { initOneSignal } from 'store/entities/localSettings/actions'
// import { oneSignalAppId } from 'store/entities/identity/selectors'
import { getIdentityAccessToken } from 'store/entities/identity/selectors'
import rootReducer from './rootReducer'
import rootSaga from './rootSaga'
import { crashReporter, createSocketIoMiddleware } from './middlewares'
import SingleSocketManager from './middlewares/createSocketIoMiddleware/socketIoConnectionManager'
import * as Sentry from '@sentry/browser'
import createSentryMiddleware from 'redux-sentry-middleware'

const sagaMiddleware = createSagaMiddleware({
  onError: e => {
    Sentry.withScope(scope => {
      scope.setExtra('where error was happen', 'in some Saga')
      Sentry.captureException(e)
    })
  },
})

const history = createBrowserHistory()
const routerMiddleware = createRouterMiddleware(history)
const socketIoMiddleware = createSocketIoMiddleware(SingleSocketManager)

const enhancer = compose(
  applyMiddleware(
    crashReporter,
    routerMiddleware,
    sagaMiddleware,
    socketIoMiddleware,
    createSentryMiddleware(Sentry, {})
  )
)

export default function configureStore(initialState) {
  const store = createStore(rootReducer(history), fromJS(initialState), enhancer)

  sagaMiddleware.run(rootSaga, { socket: SingleSocketManager })

  const persistor = persistStore(store, null, () => {
    // Load initial user data right after restoring data
    // if this is login by magic link process the same data will be got during login, so no need it
    const state = store.getState()
    // if this is login by magic link process the same data will be got during login, so no need it
    if (!isLoginByMagicLink(state) && getIdentityAccessToken(state) && !isStartPage(state)) {
      store.dispatch(getProfile())
      store.dispatch(getIdentityProgress())
    }

    // init oneSignal
    // store.dispatch(initOneSignal(oneSignalAppId(store.getState())))
  })

  return { store, history, persistor }
}
